import React from "react"
import { Link } from "@fluentui/react"
export const FileListing = ( {fileList, chargesType}) =>{
  
        
    return (
        
        <React.Fragment>

        <div className="d-flex flex-row bd-highlight mb-3 flex-wrap">
        <div className="p-2 bd-highlight"> <strong className="text-uppercase"> {chargesType}  </strong></div>
        {
          fileList && fileList.length>0 ? fileList.map((file,index)=>{
            if(file.chargesType==chargesType){
              return (
                <React.Fragment>
                <div className="p-2 bd-highlight" key={index}> 
                <Link className="badge badge-success"
                target="_blank" 
                href={`${process.env.REACT_APP_BASE_URL.replace("v1/" ,"" )}_medical/${file.medicalId}/${file.file}` } download >
                {file.originalFileName} </Link>  </div>
                 </React.Fragment>
              )
            }
          })  :" "
        }

      </div>
        </React.Fragment>
    )
}